import { createTheme } from '@mui/material';
var augmentColor = createTheme().palette.augmentColor;
export var palette = {
    primary: augmentColor({
        color: {
            main: '#80DEEA',
        },
    }),
    secondary: augmentColor({
        color: {
            main: '#0096A7',
        },
    }),
    text: {
        primary: '#fff',
        secondary: '#fff',
        dark: '#323232',
    },
    background: {
        default: '#323232',
        paper: '#323232',
    },
    // TODO: delete unused here - https://hearxgroup.atlassian.net/jira/software/c/projects/HXW/boards/458?assignee=712020%3A808a3068-5bdd-460f-96f6-7ddb91ce5ae3&selectedIssue=DIGITS-1124
    roundButton: {
        layers: {
            first: '#0096A7',
            second: '#0096A7',
            third: '#0096A7',
            forth: '#0096A7',
        },
    },
    info: augmentColor({
        color: {
            main: '#62cae6',
        },
    }),
    common: {
        black: '#353435',
        white: '#fff',
        'faux-white': '#F4F4F4',
        'faux-black': '#122B3B',
    },
    blue: {
        light: '#E6EDF9',
        medium: '#8AAAE2',
        dark: '#2A64CA',
    },
    shadow: {
        main: '#00000022',
    },
    custom: {
        normalCategory: augmentColor({
            color: { main: '#009242' },
        }),
        mildCategory: augmentColor({
            color: { main: '#EC712E' },
        }),
        moderateCategory: augmentColor({
            color: { main: '#FF0000' },
        }),
    },
};
